import cloneDeep from 'lodash/cloneDeep'
import { useParseQueryParamsToSearchFilters } from '~/composables/useParseQueryParamsToSearchFilters'

export type CategoryTypes = string | number | boolean | undefined
export interface SearchFilterOptions {
  city?: string | undefined
  priceMin?: number
  priceMax?: number
  radius?: number
  dates?: string[] | undefined
  tags?: string[] | undefined
  languages?: string[] | undefined
  categoriesBySlug?: string[] | undefined
  categories?: CategoryTypes[] | undefined
  hasAvailableDates?: boolean
  hasPromotion?: boolean
  searchquery?: string | undefined
  typeOfClass?: string
  [name: string]: CategoryTypes | CategoryTypes[]
}

const getEmptyFilters = () => ({
  typeOfClass: undefined,
  hasAvailableDates: false,
  hasPromotion: false,
  city: undefined,
  categories: [],
  languages: [],
  priceMin: 0,
  priceMax: 1200,
  searchquery: undefined,
})

export const useSearchFilters = (
  instance: string,
  defaultFilters:
    | ComputedRef<SearchFilterOptions | undefined>
    | Ref<SearchFilterOptions | undefined> = ref(undefined)
) => {
  const route = useRoute()
  const router = useRouter()
  const filters = useState<SearchFilterOptions>(`filters-${instance}`, () =>
    cloneDeep(getEmptyFilters())
  )

  // legacy category handling
  if (route.query.category) {
    const legacyCat = route.query.category?.toString().split(',')
    router.replace({
      query: {
        ...route.query,
        categories: legacyCat,
        category: undefined,
      },
    })
  }

  const { filters: filtersFromQueryParams } =
    useParseQueryParamsToSearchFilters(defaultFilters)

  watchEffect(() => {
    filters.value = filtersFromQueryParams.value
  })

  watch(
    () => route.query.searchquery,
    () => {
      filters.value = filtersFromQueryParams.value
    }
  )

  const handleFiltersReset = () => {
    filters.value.categories = defaultFilters.value?.categories || []
    filters.value.city = defaultFilters.value?.city || undefined
  }

  return {
    filters,
    handleFiltersReset,
  }
}
